/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TumorBoardOccurrenceParticipant from './tumor-board-occurrence-participant';
import TumorBoardOccurrenceParticipantDetail from './tumor-board-occurrence-participant-detail';
import TumorBoardOccurrenceParticipantUpdate from './tumor-board-occurrence-participant-update';
import TumorBoardOccurrenceParticipantDeleteDialog from './tumor-board-occurrence-participant-delete-dialog';

const TumorBoardOccurrenceParticipantRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TumorBoardOccurrenceParticipant />} />
    <Route path="new" element={<TumorBoardOccurrenceParticipantUpdate />} />
    <Route path=":id">
      <Route index element={<TumorBoardOccurrenceParticipantDetail />} />
      <Route path="edit" element={<TumorBoardOccurrenceParticipantUpdate />} />
      <Route path="delete" element={<TumorBoardOccurrenceParticipantDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TumorBoardOccurrenceParticipantRoutes;
